import Splide from '@splidejs/splide';
import {sliderOptions} from '../colorz/configClrzApp';
import {DeferWebComponent} from '@script/colorz/DeferWebComponent.js';

class ClrzSlider extends DeferWebComponent {
	constructor() {
		super();
	}

	ready() {
		this.defaultOptions = sliderOptions.default;
		this.options = !!this.dataset.options
			? sliderOptions[this.dataset.options]
			: {};
		this.options = {...this.defaultOptions, ...this.options};

		if (this.dataset.destroy == 'true') {
			this.options.destroy = true;
		}

		this.initSlider();
	}

	initSlider() {
		const splide = new Splide(this, this.options);

		splide.on('overflow', function (isOverflow) {
			if (!isOverflow) {
				splide.options = {
					arrows: false,
					pagination: false,
					drag: false,
				};
			}
		});

		splide.mount();

		if (
			this.dataset.positionArrows == 'true' &&
			this.querySelector('.splide__slide img')
		) {
			const topArrow =
				this.querySelector('.splide__slide img')?.offsetHeight / 2;
			this.querySelectorAll('.splide__arrow-wrapper').forEach((arrow) => {
				arrow.style.top = topArrow + 'px';
			});
		}

		if (this.classList.contains('splide--timeline')) {
			document.querySelectorAll('.js-dates').forEach((date) => {
				date.addEventListener('click', () => {
					const indexToGo = Number(date.dataset.index) - 1;
					splide.go(indexToGo);
				});
			});

			splide.on('move', function (newIndex) {
				const activeSlide = newIndex + 1;

				document
					.querySelector('.js-dates.is-active')
					.classList.remove('is-active');
				document
					.querySelector('.js-dates[data-index="' + activeSlide + '"]')
					.classList.add('is-active');
			});
		}

		if (this.classList.contains('splide--strate-hero')) {
			splide.on('active', function (Slide) {
				const colorPagination = Slide.slide.dataset.paginationColor;

				splide.root.style.setProperty('--pagination-color', colorPagination);
			});
		}

		const slides = this.querySelectorAll('.splide__slide');

		slides.forEach(function (slide) {
			const noDragElements = slide.querySelector('.js-stop-drag-slider');
			const dragElements = slide.querySelectorAll('.js-drag-slider');

			if (noDragElements) {
				noDragElements.addEventListener('click', function () {
					splide.options = {drag: false};
					if (this.closest('.splide__list.remove-transform')) {
						this.closest('.splide__list.remove-transform').style.transform = '';
					}
				});

				dragElements.forEach(function (element) {
					element.addEventListener('click', function () {
						splide.options = {drag: true};
					});
				});
			}
		});
	}
}

if (!customElements.get('clrz-slider')) {
	customElements.define('clrz-slider', ClrzSlider);
}
